import moment from 'moment'
import momentLocale from 'moment/min/moment-with-locales'
export const startDate = moment().subtract(30, 'days')
export const endDate = moment()
export const riskType = 'A'
export const companiesSortOptions = {
  sortBy: 'companyName',
  sortDir: 'asc',
}
export const modalEventsOptions = {
  sortBy: 'eventDate',
  sortDir: 'desc',
}

export const recentEventsOptions = {
  sortBy: 'eventDate',
  sortDir: 'desc',
}

export const scheduledExportSortOptions = {
  sortBy: 'lastModifiedDate',
  sortDir: 'desc',
}

export const previousExportSortOptions = {
  sortBy: 'exportDate',
  sortDir: 'desc',
}

export const hideScoreForCountries = []
export const showBandForCountriesWhenLocalRatingIsNotExistForCompany = ['AU']

export const dateFormatBasedOnCountry = (localeFormat) => {
  if (localeFormat === 'GB') {
    return 'DD MMM YYYY'
  } else if (localeFormat === 'JA') {
    return 'YYYY-MM-DD'
  } else {
    if (localeFormat === 'NO') {
      return momentLocale.localeData('nb').longDateFormat('L')
    } else {
      return momentLocale.localeData().longDateFormat('L')
    }
  }
}

export const exampleCSVLink = 'https://s3-eu-west-1.amazonaws.com/csconnect-helpfiles/import_template.csv'
export const exampleXLSLink = 'https://s3-eu-west-1.amazonaws.com/csconnect-helpfiles/import_template.xlsx'
export const globalRuleTooltip = {
  rule101: [
    'Checking International Rating will activate the Reduce by and the Less than band options',
    'Select here the number of rating bands a company will need to drop before you receive a daily alert, ' +
    'for example if 2 is selected a company would need to change from B to D',
    'Here you can select the Band which is the threshold for the daily alert, for example if you set to C any ' +
    'company that drops below that will generate an alert',
  ],
  rule102: [
    'Click here to activate or reactive the rules on the credit limits',
    'Selecting any will generate an alert for a company on any change to their credit limit',
    'Enter an amount that the credit limit would need to reduce by to send you an alert, ' +
    'you can also enter a negative number to be alerted of an increase in credit limit, note that this is not currency dependant',
    'Here you can enter a value that if a company’s credit limit dropped below that value you would be sent an alert',
  ],
  rule104: ['Check box to receive alerts on Company name change'],
  rule105: ['Check box to receive alerts on Address change'],
  rule106: ['Check box to receive alerts on Telephone number change'],
  rule107: ['Check box to receive alerts on Director change'],
  rule108: ['Check box to receive alerts on Payment Behaviour'],
  rule109: ['Check box to receive alerts on Payment Expectation'],
}

export const globalRulesAlert = {
  rule107: {
    alert: 'One or more companies in this portfolio does not have the data available for this rule' +
    ' - you will not receive alerts. See the user guide for exclusions.',
    countryList: ['CA'],
  },
}
export const descendingOrderKeys = ['personalLimit', 'localScore', 'lastEventDate']



// WEBPACK FOOTER //
// ./src/defaults.js